<div class="network-config-preview" fxLayout="column" fxFlex="100">
  <div class="network-config-preview_tag" fxLayout="column" fxLayoutAlign="space-between stretch">
    <div class="network-config-preview_tag-title">Select the tag to identify the item:</div>
    <form fxLayout="column">
      <input class="network-config-preview_form-input">
    </form>
  </div>
  <div class="network-config-preview_warm" fxLayout="column" fxLayoutAlign="space-between stretch">
    <div class="network-config-preview_warm-title" [innerHTML]="previewSliderLabel"></div>
    <div class="network-config-preview_warm-slider">
      <mat-slider min="1" step="1" max="11" class="network-config-preview_warm-slider-range"></mat-slider>
    </div>
    <div class="network-config-preview_warm-labels" fxLayout="row" fxLayoutAlign="space-between stretch">
      <div
        class="network-config-preview_warm-labels-left"
        [innerHTML]="previewLabelLeft"
        fxLayout="column"
        fxLayoutAlign="space-between start"
      ></div>
      <div
        class="network-config-preview_warm-labels-right"
        [innerHTML]="previewLabelRight"
        fxLayout="column"
        fxLayoutAlign="space-between end"
      ></div>
    </div>
  </div>
</div>
